import { render } from "./ErrorModal.vue?vue&type=template&id=422d9374"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"

import "./ErrorModal.vue?vue&type=style&index=0&id=422d9374&lang=css"

import exportComponent from "C:\\Assembla\\VIV0006\\root\\dev\\QuizWhiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__